// extracted by mini-css-extract-plugin
module.exports = {"tablepd":"index_tablepd_YUIJF","locked":"index_locked_qXcqc"};